import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import {
  Image,
  ImageStyle,
  StyleProp,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';

export const EmptyPlaceholder = memo(
  ({
    icon,
    iconSize,
    iconColor,
    style,
    text,
    imageStyle,
    buttonText,
    textStyle,
    buttonStyle,
    buttonTextStyle,
    error,
    onRetry,
  }: {
    text?: string;
    buttonText?: string;
    iconSize?: number;
    iconColor?: string;
    icon?: ReactNode;
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
    imageStyle?: StyleProp<ImageStyle>;
    buttonStyle?: StyleProp<ViewStyle>;
    buttonTextStyle?: StyleProp<TextStyle>;
    error?: Error;
    onRetry?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const theme = usePresentationTheme();
    iconSize = iconSize ?? rpx(28);
    return (
      <Center style={style}>
        {icon ? (
          icon
        ) : theme.emptyPlaceholder.iconImage ? (
          <Image
            source={theme.emptyPlaceholder.iconImage}
            css={`
              width: ${iconSize}px;
              height: ${iconSize}px;
              left: ${-rpx(25)}px;
            `}
            style={imageStyle}
          />
        ) : (
          <Icon
            name="file-tray-outline"
            size={iconSize}
            color={iconColor ?? theme.emptyPlaceholder.iconColor}
          />
        )}
        <Typography.Label
          regular
          color={
            error
              ? theme.emptyPlaceholder.errorTextColor
              : theme.emptyPlaceholder.textColor
          }
          css={`
            text-align: center;
            margin-top: ${rpx(40)}px;
          `}
          style={textStyle}
        >
          {text ?? '暂无相关数据'}
        </Typography.Label>
        {error != null && onRetry != null && (
          <TouchableOpacity
            css={`
              justify-content: center;
              align-items: center;
              padding: ${rpx(4)}px ${rpx(32)}px;
              border-width: 1px;
              border-color: ${theme.emptyPlaceholder.textColor};
              border-radius: ${rpx(100)}px;
              margin-top: ${rpx(40)}px;
            `}
            style={buttonStyle}
            onPress={onRetry}
          >
            <Typography.Label
              regular
              color={theme.emptyPlaceholder.textColor}
              style={buttonTextStyle}
            >
              {buttonText ?? '重新加载'}
            </Typography.Label>
          </TouchableOpacity>
        )}
      </Center>
    );
  },
);
